import { Component, Input, OnInit, TemplateRef} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from '../services/shared.service';
import { StoreService } from 'src/app/sales-rep/services/store.service';

@Component({
  selector: 'app-stores-popup',
  templateUrl: './stores-popup.component.html',
  styleUrls: ['./stores-popup.component.scss']
})
export class StoresPopupComponent implements OnInit {
  @Input() retailerId: 0;
  @Input() storeIds: [];
  noRecord = false;
  loading = false;
  nextPage = 1;
  total_stores = 0;
  store_list = [];
  constructor(public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  private sharedService: SharedService,
  private storeService: StoreService) { }
  ngOnInit() {
    if (this.storeIds !== undefined && this.storeIds.length > 0){
      this.loadingPagingData();
    }
    if (this.retailerId > 0){
      this.getRetailerStoreData();
    }
    
  }

  loadingPagingData() {
    this.storeService.getStoresByIds(this.storeIds, this.nextPage)
        .subscribe(
          data => {
            if (data.response) {
              this.store_list = data.response.results;
              this.total_stores = data.response.total_count
              if (data.response.results.length === 0) {
                this.noRecord = true;
              }
            }
            this.loading = false;
          }
        );
  }

  getRetailerStoreData() {
    this.noRecord = false;
    this.sharedService.getRetailerStore(this.retailerId, this.nextPage,'', 'True')
        .subscribe(
          data => {
            if (data.response) {
              this.store_list = data.response.results;
              this.total_stores = data.response.total_count
              this.nextPage = data.response.next;
              if (data.response.results.length === 0) {
                this.noRecord = true;
              }
            }
            this.loading = false;
          }
        );
  }
  onScrollDown() {
    if ((this.nextPage !== null && this.nextPage > 1) && !this.loading) {
      this.loading = true;
      this.sharedService.getRetailerStore(this.retailerId, this.nextPage, 'hide', 'true')
        .subscribe(
          data => {
            if (data.response) {
              const retailer_store_list = data.response.results;
              this.nextPage = data.response.next;
              this.total_stores = data.response.total_count
              if (data.response.results.length === 0) {
                this.noRecord = true;
              }
              for (let i = 0; i < retailer_store_list.length; i++) {
                this.store_list.push(retailer_store_list[i]);
              }
            }
            this.loading = false;
          }
        );
    }
  }

  openModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal store-list' }));
  }

}
